module.exports = __webpack_public_path__ + "e9e05f6d34eff5fdaa1b618e7c9cb4d4.svg";